import { ValidationError } from 'yup';

import {
  OrgAddressFilterTypesEnum,
  ORG_ADDRESS_BULK_CSV_VALIDATION_SCHEMA,
  ORG_ADDRESS_FORM_REQUIRED_FIELDS,
  ORG_ADDRESS_FORM_REQUIRED_FIELDS_WITH_STATE,
} from '../constants/addressBook';
import { IOrgAddress, TCsvRow, TCsvRowErrors, TInvalidRowsMap, TOrgAddressCsvKey } from '../types/addressBook';
import { getRequiredFieldsByCountryCode } from './country';

export const getOrgAddressFormRequiredFieldsByCountryCode = (country?: string) =>
  getRequiredFieldsByCountryCode(
    country,
    ORG_ADDRESS_FORM_REQUIRED_FIELDS_WITH_STATE,
    ORG_ADDRESS_FORM_REQUIRED_FIELDS,
  );

export const isAllOrgAddressesActive = (addressList: IOrgAddress[] | null | undefined, orgIds: string[]): boolean => {
  if (addressList) {
    return orgIds.every((id) => {
      const address = addressList.find((addr) => addr.uid === id);
      return address?.status === OrgAddressFilterTypesEnum.Active;
    });
  }
  return false;
};

export function validateOrgAddressRow(row: TCsvRow): TCsvRowErrors {
  const presentKeys = Object.keys(row).filter((k): k is TOrgAddressCsvKey => k !== 'id');
  if (presentKeys.length === 0) {
    return {};
  }

  const partial = ORG_ADDRESS_BULK_CSV_VALIDATION_SCHEMA.pick(presentKeys);
  try {
    partial.validateSync(row, { abortEarly: false });
    return {};
  } catch (err: unknown) {
    const errors: TCsvRowErrors = {};
    if (err instanceof ValidationError && Array.isArray(err.inner)) {
      err.inner.forEach((e: ValidationError) => {
        if (e.path) {
          errors[e.path] = e.message;
        }
      });
    }
    return errors;
  }
}

export function collectInvalidRows(rows: TCsvRow[]): TInvalidRowsMap {
  const acc: TInvalidRowsMap = {};
  rows.forEach((row) => {
    const errors = validateOrgAddressRow(row);
    if (Object.keys(errors).length) {
      acc[String(row.id)] = errors;
    }
  });
  return acc;
}
